import * as React from 'react';
import { connect } from 'react-redux';

import BooksMenuItem from '../../../../components/books/model1/BooksMenuItem';
import { Course } from '../../../../interfaces/merchants/resources/books';

interface Props {
  courses: Course[];
  postable: boolean;
  onClick: (course: Course) => void;
}

class InputBookingTargetCourseSelector extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClickCourse = this.handleClickCourse.bind(this);
  }

  public handleClickCourse(e: React.MouseEvent<HTMLInputElement>) {
    const { courses, onClick } = this.props;
    const course = courses.find(c => String(c.id) === e.currentTarget.value)!;
    onClick(course);
  }

  public render() {
    const { courses, postable } = this.props;

    return (
      <div>
        {courses.map(course => (
          <BooksMenuItem
            key={course.id}
            courseName={course.name}
            image={course.image}
            price={course.price}
            duration={course.duration}
            onClick={this.handleClickCourse}
            postable={postable}
            text={course.description}
            value={course.id}
          />
        ))}
      </div>
    );
  }
}

export default connect()(InputBookingTargetCourseSelector);
